import React, { useContext, useEffect } from 'react'
import Announces from "../../Components/Announces/Announces"
import Schedule from "../../Components/Schedule/Schedule"
import Banners from "../../Components/Banners"
import { FilterContext, TourContext } from "../../../context/index"
import { GET_ANNOUNCES } from "../../../graphql/index"
import {INITIAL_HISTORY, RELEVANT_INITIAL_FILTER} from "../../../constant"
import css from '../../Layout/Layout.module.scss'
import {getCookie} from "../../../utils";

const Search = () => {
	const { filter } = useContext(FilterContext)
	const { tour, openTour } = useContext(TourContext)

	const isLoading = (loading) => {
		// if(!loading && (!getCookie('initialTour') && getCookie('initialTour') !== '0')){
		// 	openTour({
		// 		stepIndex: tour.stepIndex || 2,
		// 		tour: true
		// 	})
		// }
	}

	return (
		<>
			<div className={css.content}>
				<Announces
					isLoading={isLoading}
					dataTarget={'main'}
					key={1}
					title="Самое важное"
					tooltip="Самые главные события дня в стране и мире"
					variables={{...RELEVANT_INITIAL_FILTER,...filter, ...{limit: RELEVANT_INITIAL_FILTER['limit']}}}
					limit={RELEVANT_INITIAL_FILTER['limit']}
					query={GET_ANNOUNCES}
					linkMore={true}
				/>
			    <Announces
				    dataTarget={'relevant'}
				    key={2}
				    title="Все события"
				    variables={filter}
				    counter={true}
				    query={GET_ANNOUNCES}
				    limit={filter['limit']}
				    buttonMore={true}
			    />
			</div>
			<div className={css.sidebar}>
				<div className={css.sidebarSticky}>
					 <Schedule
						 dataTarget={'history'}
						 title="День в истории"
						 tooltip="Календарные и памятные даты"
						 variables={{...INITIAL_HISTORY,...{fd:filter.fd, td: null}}}/>
					<Banners
						code={`
							<div id="adfox_170366347869696999"></div>
							<script>
								window.yaContextCb?.push(() => {
								window.Ya?.adfoxCode?.create({
									ownerId: 249922,
									containerId: 'adfox_170366347869696999',
									params: {
										pp: 'dygy',
										ps: 'hdeu',
										p2: 'fluh',
										puid1: '',
										puid2: '',
										puid3: '',
										puid4: '',
										puid5: '',
										puid6: ''
									}
								})
							})
							</script>`
						}
					/>
				</div>
			</div>
		</>
	)
}
export default Search